(() => {
  'use strict';
  if (window.KiddilFooterCrest) {
    window.KiddilFooterCrest.scan(document);
    return;
  }
  const selector = '[data-kiddil-footer-crest="bunny-hello"]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();

  function settle(state) {
    state.finished = true;
    state.element.dataset.kiddilMotion = 'complete';
    delete state.element.dataset.kiddilMotionPaused;
    if (observer) observer.unobserve(state.element);
  }
  function sync(state) {
    if (state.finished) return;
    if (reducedMotion.matches) {
      settle(state);
      return;
    }
    const paused = !state.visible || document.hidden;
    if (!state.started && !paused) {
      state.started = true;
      state.element.dataset.kiddilMotion = 'playing';
    }
    state.element.toggleAttribute('data-kiddil-motion-paused', paused);
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      sync(state);
    });
  }, { threshold: 0.2 }) : null;

  function scan(scope) {
    const elements = [...scope.querySelectorAll(selector)];
    if (scope.matches && scope.matches(selector)) elements.unshift(scope);
    elements.forEach(element => {
      if (states.has(element)) return;
      const state = { element, visible: false, started: false, finished: false };
      states.set(element, state);
      element.dataset.kiddilMotion = 'ready';
      element.addEventListener('animationend', event => {
        if (event.animationName === 'kiddil-footer-bunny-hello-v1') settle(state);
      });
      // Without visibility observation the full badge remains safely static.
      if (!observer || reducedMotion.matches) settle(state);
      else observer.observe(element);
    });
  }
  const onPreferenceChange = () => states.forEach(sync);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onPreferenceChange);
  else reducedMotion.addListener(onPreferenceChange);
  document.addEventListener('visibilitychange', () => states.forEach(sync));
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, element) => {
      if (event.target.contains(element)) {
        if (observer) observer.unobserve(element);
        states.delete(element);
      }
    });
  });
  window.KiddilFooterCrest = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
